let mdName = function(str){
  if(!str) return;
  if(str.length >= 7){
    return str.substr(0,3)+'****'+ str.substring(str.length-6)
  }else{
      return str;
  }
}
// 全局去掉小数点2位和4位
let toFixed4 = function(val){
  // if(val == 0 || val){
  //   val = Number(val);
  //   return val.toFixed(4);
  // }else{
  //   return ''
  // }
  return val
}
let toFixed2 = function(val){
  // val = Number(val);
  // return val.toFixed(2);
  return val
}

let rewriteName = function(val){
  let bzName = val;
  if(val == 'CMGCA0'){
    bzName = 'XAU';
    return bzName
  }else if(val == 'CMSIA0'){
    bzName = 'XAG';
    return bzName
  }else if(val == 'CMHGA0'){
    bzName = 'BRT';
    return bzName
  }else if(val == 'NECLI0'){
    bzName = 'OILFUT';
    return bzName
  }else if(val == 'NEHOI0'){
    bzName = 'NYMEX';
    return bzName
  }else if(val == 'NENGA0'){
    bzName = 'NG';
    return bzName
  }else if(val == 'NEPAA0'){
    bzName = 'XPD';
    return bzName
  }else if(val == 'NEPLA0'){
    bzName = 'PTB';
    return bzName
  }else if(val == 'NEQMA0'){
    bzName = 'QMOIL';
    return bzName
  }else if(val == 'NERBA0'){
    bzName = 'RBOB';
    return bzName
  }else{
    return bzName
  }
}
let timeGs = function(val){
  var date = new Date((val) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  var dates = Y + M + D + " " + h + m + s;;
  if(dates){
    let times = dates.split('-');
    let timess = times[2].split(' ');
    let mm = times[1];
    let dd = timess[0];
    let year = times[0];
    let sfm = timess[1];
    return year + '-' + mm + '-' + dd + " " + sfm;;
  }
}
let timeGs2 = function(val){
  var date = new Date((val) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  var dates = Y + M + D;
  if(dates){
  let times = dates.split('-');
  let mm = times[1];
  let dd = times[2];
  let year = times[0];
  return year + '-' + mm + '-' + dd
  }
}
export {rewriteName,timeGs,timeGs2,mdName,toFixed4,toFixed2}



// WEBPACK FOOTER //
// ./src/utils/filters.js